<content>
    <section class="filters-framed" style="margin-bottom: 2rem;">
        <form [formGroup]="newEditForm" [ngClass]="{ 'show-error': showError }">
            <div class="info">{{'global.infoRequired' | translate}}</div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-modal' : 'entry-4-modal'" class="calendar">
                <label>{{'mantenimientoExpediciones.fecha' | translate}} *</label>
                <input [matDatepicker]="fecha" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fecha" (click)="fecha.open()">
                <mat-datepicker #fecha></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-modal' : 'entry-4-modal'">
                <label>{{'global.matricula' | translate}} *</label>
                <input type="text" formControlName="matricula">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-modal' : 'entry-4-modal'">
                <label>{{'mantenimientoExpediciones.deliveryNote' | translate}} *</label>
                <input type="text" formControlName="albaran">
            </div>
        </form>
    </section>

    <div class="table-wrapper-bigger">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="date">{{ 'global.fecha.confeccion' | translate }}</th>
                        <th class="string">{{ 'global.lote' | translate }}</th>
                        <th class="string">{{ 'global.denominacion' | translate }}</th>
                        <th class="string">{{ 'global.finca' | translate }}</th>
                        <th class="string">{{ 'global.confeccion' | translate }}</th>
                        <th class="string">{{ 'global.type' | translate }}</th>
                        <th class="string">{{ 'mantenimientoExpediciones.available' | translate }}</th>
                        <th class="string">{{ 'global.unidades' | translate }} *</th>
                        <th class="actions"></th>
                    </tr>
                </thead>
                <tbody *ngFor="let expedicion of expediciones; let i = index">
                    <tr>
                        <td class="date">{{ expedicion.fechaConfeccion | date: 'shortDate' : undefined : defaultLanguage }}</td>
                        <td class="string">{{ expedicion.lote }}</td>
                        <td class="string">{{ expedicion.desDenominacion }}</td>
                        <td class="string">{{ expedicion.desFinca }}</td>
                        <td class="string">{{ expedicion.desConfeccion }}</td>
                        <td class="string">{{ expedicion.tipoConfeccionId === 1 ? ('global.caja' | translate) : expedicion.tipoConfeccionId === 2 ? ('global.pallet' | translate) : '' }}</td>
                        <td class="string">{{ expedicion.unidadesDisponibles | number : '1.0-0': defaultLanguage }}</td>
                        <td class="string">
                            <input style="max-width: 100%" type="string" [value]="expedicionId ? expedicion.unidades || 0 : expedicion.unidadesDisponibles || 0"
                                (change)="updateUnits(i, $event.target.value)"
                                [ngStyle]="showError && (!allUnits[i] || !expedicion.rightFormat || (allUnits[i] && allUnits[i] > (expedicion.unidadesDisponibles || 0))) ? {'border': '1px solid #dc2828', 'border-left-width': '3px'} : ''">
                        </td>
                        <td class="actions">
                            <!-- No se permite borrar si solo hay 1 confección -->
                            <i class="far fa-trash-alt" [ngClass]="{ 'disabled': expediciones.length === 1 }" title="{{'titles.eliminar' | translate}}" app-click-stop-propagation (click)="showDeleteModal(i)"></i>
                        </td>
                    </tr>
                </tbody>

                <tfoot *ngIf="!expediciones || (expediciones && expediciones.length < 1)">
                    <tr>
                        <td colspan="8">
                            {{ 'global.noContent' | translate }}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</content>

<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{ 'mantenimientoExpediciones.confirmarExpedicion' | translate }}</button>
</footer>

<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.eliminar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.eliminar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
            <button (click)="delete()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>

<app-toast *ngIf="mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>